package ch.wsl.box.model.shared

case class LoginRequest(username:String,password:String)